import { render, staticRenderFns } from "./ReportAddToCart.vue?vue&type=template&id=8f735bf4&"
import script from "./ReportAddToCart.vue?vue&type=script&lang=js&"
export * from "./ReportAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports